import { render } from "./SocialPhotoSelector.vue?vue&type=template&id=7fd82663"
import script from "./SocialPhotoSelector.vue?vue&type=script&lang=js"
export * from "./SocialPhotoSelector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__